export default (function (type) {
    return type === 'text/directory';
});
